import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async searchByName(text) {
    try {
      let res = await HTTP.normal.get(
        `/accounts?include=accountable&filter[email]=${text}&filter[accountable_type]=Legal,Physical&page[size]=5`
      );

      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar os clientes pelo nome!";
    }
  },

  async sendVerificationEmail(account_id) {
    try {
      let data = {
        data: {
          id: account_id,
          type: "accounts"
        }
      };
      await HTTP.normal.post(`/email-verification/send`, data);
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/clients.js